<div class="flex min-h-screen bg-amber-400" #pageContainer>
  <!-- Left side - Image/Banner -->
  <div
    class="hidden md:flex md:w-1/2 bg-cover bg-center relative"
    [style.backgroundImage]="'url(assets/repartidor.png)'"
    >
    <div
      class="absolute inset-0  bg-gray-950/50 flex flex-col justify-end p-12 text-white"
      >
      <h2 class="text-4xl font-bold mb-2">Delivery rápido y seguro</h2>
      <p class="text-xl">Tu comida favorita en minutos</p>
    </div>
  </div>

  <!-- Right side - Login Form -->
  <div

    class="w-full md:w-1/2 flex items-center justify-center p-8 bg-amber-400 relative"
    style="
      background-image: url('assets/patrones/fondo_patron_subito.webp');
      background-size: 200px 200px;
      background-repeat: repeat;
      background-position: center;
    "
    >
    <!-- Home button positioned in the top-left corner -->
    <div class="absolute top-4 left-4">
      <shared-home-button></shared-home-button>
    </div>

    <div
      class="w-full max-w-2xl bg-white rounded-4xl shadow-lg p-8"
      #cardContainer
      >
      <div class="text-center mb-10">
        <div class="flex justify-center mb-4">
          <a [routerLink]="['/']">
            <figure>
              <img
                ngSrc="assets/logo/logo_full.png"
                alt="Logo"
                width="300"
                height="80"
                priority="high"
                class="h-20 w-auto"
                />
              </figure>
            </a>
          </div>
          <p class="text-gray-600 mt-2">Delivery instantáneo a tu puerta</p>
        </div>

        <h2 class="text-2xl font-bold text-gray-800 mb-6">Bienvenido de nuevo</h2>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-6">
          <!-- Email Field -->
          <div class="form-field">
            <label
              for="email"
              class="block text-sm font-medium text-gray-700 mb-1"
              >Email</label
              >
              <input
                type="email"
                id="email"
                formControlName="email"
                class="w-full px-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
            [ngClass]="{
              'border-red-500':
                email?.invalid && (email?.dirty || email?.touched)
            }"
                placeholder="tu@email.com"
                />
                @if (email?.invalid && (email?.dirty || email?.touched)) {
                  <div
                    class="text-red-500 text-sm mt-1"
                    [@errorAnimation]
                    >
                    @if (email?.errors?.['required']) {
                      <div>El email es requerido</div>
                    }
                    @if (email?.errors?.['email']) {
                      <div>
                        Por favor ingresa un email válido
                      </div>
                    }
                  </div>
                }
              </div>

              <!-- Password Field -->
              <div class="form-field">
                <label
                  for="password"
                  class="block text-sm font-medium text-gray-700 mb-1"
                  >Contraseña</label
                  >
                  <div class="relative">
                    <input
                      type="{{ showPassword() ? 'text' : 'password' }}"
                      id="password"
                      formControlName="password"
                      class="w-full pr-12 pl-4 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 bg-white"
                      [ngClass]="{
                        'border-red-500':
                          password?.invalid && (password?.dirty || password?.touched)
                      }"
                      placeholder="••••••••"
                    />

                    <button
                      type="button"
                      (click)="toggleShowPassword()"
                      class="absolute inset-y-0 right-0 flex items-center px-3 text-amber-500"
                      aria-label="Mostrar u ocultar contraseña"
                    >
                      @if (!showPassword()) {
                        <i class="fas fa-eye"></i>
                      }
                      @if (showPassword()) {
                        <i class="fas fa-eye-slash"></i>
                      }
                    </button>
                  </div>

                    @if (password?.invalid && (password?.dirty || password?.touched)) {
                      <div
                        class="text-red-500 text-sm mt-1"
                        [@errorAnimation]
                        >
                        @if (password?.errors?.['required']) {
                          <div>
                            La contraseña es requerida
                          </div>
                        }
                        @if (password?.errors?.['minlength']) {
                          <div>
                            La contraseña debe tener al menos 6 caracteres
                          </div>
                        }
                      </div>
                    }
                  </div>

                  <!-- Remember Me & Forgot Password -->
                  <div class="flex items-center justify-center form-field">
                    <a
                      [routerLink]="['/auth/recovery-password']"
                      class="text-sm text-amber-500 hover:text-amber-600 font-medium"
                      >¿Olvidaste tu contraseña?</a
                      >
                    </div>

                    <!-- Submit Button -->
                    <button
                      type="submit"
                      [disabled]="loginForm.invalid || isLoading"
                      class="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-white bg-amber-500 hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
                      #loginButton
                      (mouseenter)="onButtonMouseEnter()"
                      (mouseleave)="onButtonMouseLeave()"
                      >
                      @if (!isLoading) {
                        <span class="flex items-center">
                          Iniciar Sesión
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5 ml-2"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            >
                            <path
                              fill-rule="evenodd"
                              d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
                              clip-rule="evenodd"
                              />
                            </svg>
                          </span>
                        }
                        @if (isLoading) {
                          <span class="flex items-center">
                            <svg
                              class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              >
                              <circle
                                class="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                stroke-width="4"
                              ></circle>
                              <path
                                class="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                            Procesando...
                          </span>
                        }
                      </button>
                    </form>

                    <!-- Register Link -->
                    <div class="text-center mt-6 form-field">
                      <p class="text-sm text-gray-600">¿No tienes una cuenta?</p>
                      <a
                        [routerLink]="['/auth/register']"
                        class="text-amber-500 hover:text-amber-600 font-medium cursor-pointer"
                        >Regístrate ahora</a
                        >
                      </div>

                      <!-- Footer -->
                      <div class="text-center text-xs text-gray-500 mt-10">
                        © 2025 Súbito. Todos los derechos reservados.
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Modal Verificación Email -->
                <resend-email-verification
                  [open]="showEmailVerificationModal"
                  (closed)="onCloseEmailVerification()"
                  [email]="loginForm.get('email')?.value"
                ></resend-email-verification>
